import { useState } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../constants.js';
import { useCustomSIPHeaderForm } from '../hooks/useCustomSIPHeaderForm.js';
import useGetCustomSIPHeaderOptions from '../queries/useGetCustomSIPHeaderOptions.jsx';
import useGetCarriers from '../queries/useGetCarriers.jsx';

const CustomSIPHeaderLinkObjectName = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { updateFormData, formData } = useCustomSIPHeaderForm();
    const { data: optionsData, isLoading: isLoadingOptions } =
        useGetCustomSIPHeaderOptions();

    const shouldFetchCarriers = formData.customHeaderTypeID === 'Carrier';
    const { data: carriersData, isLoading: isLoadingCarriers } = useGetCarriers(
        { enabled: shouldFetchCarriers },
    );

    const getLinkObjectOptions = () => {
        if (!formData.customHeaderTypeID) {
            return [];
        }

        if (formData.customHeaderTypeID === 'Carrier') {
            if (!carriersData) return [];
            return Array.isArray(carriersData) ? carriersData : [];
        }

        if (!optionsData) return [];
        const typeKey = formData.customHeaderTypeID;
        return optionsData[typeKey] || optionsData.linkOptions || [];
    };

    const linkObjectOptions = getLinkObjectOptions();
    const isLoading = shouldFetchCarriers
        ? isLoadingCarriers
        : isLoadingOptions;

    const handleSelectChange = (item) => {
        updateFormData(FORM_FIELD_PATHS.LINK_ID, item?.id || '');
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[FORM_FIELD_PATHS.LINK_ID] &&
                touched[FORM_FIELD_PATHS.LINK_ID]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Link Object Name{' '}
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Choose the specific name of the chosen entity type.
                    </Text>
                </Box>
                <Field
                    component={DropDown}
                    name={FORM_FIELD_PATHS.LINK_ID}
                    data={linkObjectOptions}
                    width="100%"
                    shownValue="name"
                    handleSelectChange={handleSelectChange}
                    placeholder={
                        isLoading
                            ? 'Loading options...'
                            : !formData.customHeaderTypeID
                              ? 'Select a type first'
                              : 'Choose entity name'
                    }
                    isDisabled={isLoading || !formData.customHeaderTypeID}
                    darkMode={darkMode}
                    noPadding={false}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Choose the specific entity name"
                        ariaLabel="custom-sip-header-link-object-name-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default CustomSIPHeaderLinkObjectName;
